export default __webpack_public_path__ + "static/media/Q4-2.e15218ff.jpg";